import styled from '@styled';
import { font_nunito } from '../global.styles';

interface StyledAProps {
  fontSize?: string;
  color?: string;
  margin?: string;
  padding?: string;
  textdecoration?: string;
  fontWeight?: string;
  display?: string;
  background?: string;
  radius?: string;
  fontFamily?: string;
  textAlign?: string;
}

export const StyledA = styled('a').withConfig({
  shouldForwardProp: (prop) => !['listPositfontSizeion', 'fontWeight', 'fontFamily', 'textAlign'].includes(prop),
})<StyledAProps>`
  font-size: ${(props) => props.fontSize || '16px'};
  color: ${(props) => props.color || '#000'};
  margin: ${(props) => props.margin || '0'};
  padding: ${(props) => props.padding || '0'};
  text-decoration: ${(props) => props.textdecoration || 'none'};
  font-weight: ${(props) => props.fontWeight || '500'};
  display: ${(props) => props.display || 'initial'};
  background: ${({ backgroundColor }) => backgroundColor || 'none'};
  border-radius: ${({ radius }) => radius || '0'};
  font-family: ${(props) => props.fontFamily || font_nunito};
  text-align: ${(props) => props.textAlign || 'start'};
  width: ${(props) => props.width || 'initial'};
  box-shadow: ${(props) => props.boxShadow || 'none'};
`;
